import { initial } from 'lodash';
import React, { useState, useEffect } from 'react';
import SelectInput from '../misc/SelectInput.js';

import './RecruitingFilterBtn.css';

const RecruitingFilterBtn = ({ initialFilters, allGradYears, allSports, allPositions, actionUrl }) => {
  const [formVals, setFormVals] = useState({ sport: '', position: '' });
  const [availablePositions, setAvailablePosition] = useState([]);
  const [numOfPositions, setNumOfPositions] = useState(0);
  const [checkedItems, setCheckedItems] = useState(undefined);

  let gradYearOptions = allGradYears.map((year, idx) => {
    let defaultChecked = initialFilters.grad_years.indexOf(year) >= 0;
    return (
      <div key={idx} className="col-6 col-sm-3 text-start">
        <div className="checkbox position-relative">
          <input type="checkbox" id={`grad-${year}`} name="grad_years[]" value={year} defaultChecked={defaultChecked} />
          <label htmlFor={`grad-${year}`}>
            {year}
          </label>
        </div>
      </div>
    );
  });

  const alphaSort = (objArr) => {
    return objArr.sort((a, b) => a.name < b.name ? -1 : 1);
  }

  let sportOptions = alphaSort(allSports).map((sport, idx) => {
    return (
      <option key={sport.id} value={sport.id}>{sport.name}</option>
    );
  });

  useEffect( () => {
    const sport = initialFilters.sport || '';
    const position = initialFilters.position || '';
    setFormVals({ sport: sport, position: position })
  }, [initialFilters])

  useEffect( () => {
    let positionOptions = null;
    if (formVals.sport) {
      let possiblePositions = allPositions.filter( p => p.sport_id === formVals.sport );
      setNumOfPositions(possiblePositions.length);
      positionOptions = alphaSort(possiblePositions).map((p, idx) => {
        return  <option key={p.id} value={p.id}>{p.name}</option>;
      });
    }
    setAvailablePosition(positionOptions);
  }, [formVals.sport])

  const onChangeHandler = e => {
    const name = e.target.name;
    const selectVal = e.target.value;
    if (e.target.value) {
      setFormVals({ ...formVals, [name]: parseInt(selectVal, 10) });
    } else {
      setFormVals({ ...formVals, [name]: '' });
    }
  }

  const changedChecked = e => {
    let year = parseInt(e.target.value);
    console.log('chekedItems', checkedItems);

    setCheckedItems({ ...checkedItems, [year]: !checkedItems[year] })
  }

  const resetForm = () => {
    setFormVals({ sport: '', position: '' });
    setYears();
  }

  const cancel = e => {
    e.preventDefault();
    resetForm();
  }

  return (
    <>
      <div id="MobileOverlay" className="d-md-block">
        <a className="selector" data-bs-toggle="modal" data-bs-target="#RecruitingFilterModal" title="Filters">
          <i className="fa-solid fa-filters"></i>
          <span className="d-none d-sm-inline FilterTxt">Filter</span>
        </a>
        <div className="modal fade" id="RecruitingFilterModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Recruiting Filter</h5>
                <button type="cancel" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <form action={actionUrl}>
                  <table>
                    <tbody>
                      {gradYearOptions.length > 0 ? (
                        <>
                          <tr>
                            <td>
                              Grad&nbsp;Year
                            </td>
                            <td className="CellSpacer"></td>
                            <td>
                              <div className="row">
                                {gradYearOptions}
                              </div>
                            </td>
                          </tr>
                          <tr><td className="CellSpacer">&nbsp;</td></tr>
                        </>
                      ) : null}
                      <tr>
                        <td>
                          <label forhtml="sport">Sport</label>
                        </td>
                        <td></td>
                        <td>
                          <span className="InputSelect">
                            <SelectInput id="sport" name="sport" value={formVals.sport} onChange={onChangeHandler}>
                              <option value="">Any Sport</option>
                              {sportOptions}
                            </SelectInput>
                          </span>
                        </td>
                      </tr>
                      <tr><td className="CellSpacer">&nbsp;</td></tr>
                      <tr>
                        <td>
                          <label forhtml="position">Position</label>
                        </td>
                        <td></td>
                        <td>
                          {
                            (formVals.sport === '' ) ? (
                              <span className="InfoMsg">Pick a sport to see available positions.</span>
                            ) : ( formVals.sport !== '' && numOfPositions === 0 ) ? (
                              <span className="InfoMsg">This sport has no positions.</span>
                            ) : (
                              <span className="InputSelect">
                                <SelectInput id="position" name="position" value={formVals.position} onChange={onChangeHandler}>
                                  <option value="">Any Position</option>
                                  {availablePositions}
                                </SelectInput>
                              </span>
                            )
                          }
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="d-flex justify-content-between pt-3">
                    <button className="btn btn-outline-secondary" type="reset" onClick={cancel} data-bs-dismiss="modal" aria-label="Close">Cancel</button>
                    <button className="btn u-layoutBtnColor" type="submit">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default RecruitingFilterBtn;
